import { Fade } from 'react-awesome-reveal';
import styled from '@emotion/styled';
import {
  BlockWrapper,
  BlockHeader,
  BlockTitle,
  BlockContentWrapper,
  CUSTOM_BREAK_POINT,
} from '../Block.styled';
import StoryItem from './StoryItemSecond';
import StoryItemFirst from './StoryItemFirst';
import StoryItemSecond from './StoryItemSecond';
import StoryItemThird from './StoryItemThird';

type Props = {
  id: string;
};

const Story = (props: Props) => {
  return (
    <BlockWrapper id={props.id}>
      <BlockHeader>
        <Fade cascade damping={0.3} direction='up' triggerOnce>
          <BlockTitle>Gummy's Story</BlockTitle>
        </Fade>
      </BlockHeader>
      <BlockContentWrapper>
        <StoryWrapper>
          <Fade cascade damping={0.6} triggerOnce>
            <StoryItemFirst />
            <StoryItemSecond />
            <StoryItemThird />
          </Fade>
        </StoryWrapper>
      </BlockContentWrapper>
    </BlockWrapper>
  );
};

const StoryWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  max-width: 1352px;
  width: 100%;

  height: 100%;

  @media (max-width: ${CUSTOM_BREAK_POINT}px) {
    justify-content: center;
    gap: 60px;
  }
`;

export default Story;
